// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FastbackIconSignature {
  Element: SVGSVGElement;
}

export const FastbackIcon: TOC<FastbackIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.375 3L14.625 4.561L5.601 11.78L14.624 18.999L13.375 20.561L3.375 12.561C3.138 12.372 3 12.084 3 11.78C3 11.476 3.138 11.189 3.375 11L13.375 3ZM18.879 5.029C18.211 4.701 17.361 4.787 16.772 5.246L10.4 10.202C9.91 10.584 9.629 11.159 9.629 11.78C9.629 12.401 9.91 12.976 10.401 13.358L16.773 18.315C17.368 18.777 18.182 18.873 18.88 18.532C19.56 18.198 20 17.493 20 16.735V6.825C20 6.067 19.56 5.362 18.879 5.029ZM18 16.736L11.629 11.781L18 6.825V16.736Z"/>
</svg>
</template>;